/**
 * @fileoverview GET handler for the "/engagement/preset_draganddrop_templates" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetDraganddropTemplates } from "./constants";
import type { EngagementPresetDraganddropTemplatesResult } from "./types";

export const getEngagementPresetDraganddropTemplates = reactQueryFetcherAdapter(
  engagementPresetDraganddropTemplates,
  (signal: AbortSignal): Promise<EngagementPresetDraganddropTemplatesResult> => {
    return fetch("/engagement/preset_draganddrop_templates", "GET", {}, { signal });
  }
);
